import React, { Component } from 'react';

class CompanyOverviewClaim extends Component {
    constructor(props) {
        super(props);
        this.state = {
            claimData: ['-', '-', '-', '-', '-', '-', '-', '-'],
            loader: false
        };
    }
    componentDidUpdate(prevProp) {
        if (prevProp.data.RequestJson != this.props.data.RequestJson && this.props.data.type == "Claim") {
            this.fetchData_locally();
        }
    }
    componentDidMount() {
        if (this.props.data.type == "Claim") {
            this.fetchData_locally();
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }
    fetchData_locally() {
        this.setState({
            loader: true,
            IsDataLoaded: false
        });
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'requestHeader': this.props.data.RequestJson1, 'X-Browser-Url': window.location.href },
            body: this.props.data.RequestJson
        };
        return fetch(this.props.data.url, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                try {
                    this.setState({ claimData: apidata[0].legend, loader: false });
                }
                catch (error) {
                }
            });
    }
    render() {
        return (
            <div className="claimOverview">
                <div className="claimSection">
                    {
                        this.state.claimData.map((item, index) => {
                            if (index < 4) {
                                return (
                                    <div className="paid" key={"paid-claims" + index}>
                                        {
                                            this.state.loader ? 
                                            <div className="loader-section"><div className="theme-loader"></div></div> : null
                                        }
                                        <span className="small">{item.legendText}</span>
                                        <span>{item.legendValue}</span>
                                    </div>
                                )
                            }
                        })
                    }
                </div>
                    <div className="claimSection bottom">
                        {
                            this.state.claimData.map((item, index) => {
                                if (index >= 4 && index <8) {
                                    return (
                                        <div className="paid" key={"paid-claims" + index}>
                                            {
                                                this.state.loader ?
                                                    <div className="loader-section"><div className="theme-loader"></div></div> : null
                                            }
                                            <span className="small">{item.legendText}</span>
                                            <span>{item.legendValue}</span>
                                        </div>
                                    )
                                }
                            })
                        }
                </div>
                <div className="claimSection bottom">
                    {
                        this.state.claimData.map((item, index) => {
                            if (index >= 8) {
                                return (
                                    <div className="paid" key={"paid-claims" + index}>
                                        {
                                            this.state.loader ?
                                                <div className="loader-section"><div className="theme-loader"></div></div> : null
                                        }
                                        <span className="small">{item.legendText}</span>
                                        <span>{item.legendValue}</span>
                                    </div>
                                )
                            }
                        })
                    }
                </div>
            </div>
        )
    }
}
export default CompanyOverviewClaim;